import { render, staticRenderFns } from "./PassRulePage.vue?vue&type=template&id=93eac55c&scoped=true&"
import script from "./PassRulePage.vue?vue&type=script&lang=js&"
export * from "./PassRulePage.vue?vue&type=script&lang=js&"
import style0 from "./PassRulePage.vue?vue&type=style&index=0&id=93eac55c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93eac55c",
  null
  
)

export default component.exports